import type { IDictionariesMap, IDictionary } from '@sravni/types/lib/dictionaries';
import type { IVitrinaConfig } from '@sravni/vitrina/lib/types/config/IVitrinaConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface IState {
  productConfig: IVitrinaConfig;
  dictionaries: IDictionariesMap;
  products: Record<string, IProduct>;
}

const initialState: IState = {
  productConfig: null,
  dictionaries: null,
  products: null,
};

const productPopupInfoSlice = createSlice({
  name: 'productPopupInfo',
  initialState,
  reducers: {
    setProductConfig: (state, { payload }: PayloadAction<IVitrinaConfig>) => {
      state.productConfig = payload;
    },
    setDictionaries: (state, { payload }: PayloadAction<Record<string, IDictionary>>) => {
      state.dictionaries = payload;
    },
    setProducts: (state, { payload }: PayloadAction<Record<string, IProduct>>) => {
      state.products = payload;
    },
  },
});

const { actions, reducer } = productPopupInfoSlice;

export const { setProductConfig, setProducts, setDictionaries } = actions;

export default reducer;
